import { useEffect, useMemo, useState } from 'react';

export const calcWindowSubtractedHeight = ({ windowHeight, otherContentHeight = 0, minHeight = 480 } = {}) => {
  const safeWindowHeight = Number.isFinite(windowHeight) ? windowHeight : 0;
  const safeOther = Number.isFinite(otherContentHeight) ? otherContentHeight : 0;
  const safeMin = Number.isFinite(minHeight) ? minHeight : 0;

  return Math.max(safeMin, Math.floor(safeWindowHeight - safeOther));
};

const useWindowSubtractedHeight = ({ otherContentHeight = 0, minHeight = 480 } = {}) => {
  const [windowHeight, setWindowHeight] = useState(() => (typeof window !== 'undefined' ? window.innerHeight : 0));

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const onResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  }, []);

  return useMemo(
    () => calcWindowSubtractedHeight({ windowHeight, otherContentHeight, minHeight }),
    [windowHeight, otherContentHeight, minHeight]
  );
};

export default useWindowSubtractedHeight;
